import { CAF_ANALYSIS_TYPE_MAP } from '../../../../../model/caf.interface'
import { useCafLessonDiffV5 } from '../../../../../modules/apis/student/lesson'
import { useCafAnalysisComponentDetailV5 } from '../../../../../modules/apis/webview/caf'
import { CAF_LEVEL_MAX } from '../../../../../modules/consts/caf'
import useIsMobile from '../../../../../modules/hooks/common/useIsMobile'
import findWordingKey from '../../../../../modules/hooks/webview/caf/common/findWordingKey'
import useCafLessonDiffData from '../../../../../modules/hooks/webview/caf/common/useCafLessonDiffData'
import { n_caf } from '../../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import LoadingSpinner from '../../../../common/LoadingSpinner'
import useMetricSidePopup from '../../../../student/portal/lessons/caf/CAFOverview/popup/useMetricSidePopup'
import Card from '../../common/Card'
import { ProgressBarNoDetail } from '../../common/ProgressBox'
import { LevelDescription } from '../LevelDescription'

const FLUENCY_TAG = 3
const FluencyIntroSection = ({ componentId }) => {
  const { t } = useTranslation()
  const isMobile = useIsMobile()
  useMetricSidePopup('Fluency')
  const { data, isLoading } = useCafAnalysisComponentDetailV5(+componentId)
  const { data: diffData } = useCafLessonDiffV5()
  const { diffDataAsTag, isFirst, Icon, diffColors, title, description } = useCafLessonDiffData(diffData, FLUENCY_TAG)

  if (isLoading || !data)
    return (
      <div className="flex h-[100px] w-[100%] items-center justify-center">
        <LoadingSpinner show primary />
      </div>
    )
  if (isMobile) {
    return (
      <>
        <Card clx="mb-[12px] mx-[20px] bg-white mt-[16px]">
          <div className="flex justify-between">
            <span className="text-[20px] font-bold text-purple-500">
              <span className="text-purple-500 ">
                {t(n_caf.fluency.level_score)} {data.level_rough}
              </span>
              <span className="text-gray-200 ">/9</span>
            </span>
          </div>
          <ProgressBarNoDetail levelExact={data?.level_exact} totalNum={CAF_LEVEL_MAX} hideFraction />
          {isFirst ? (
            <div className="mt-[12px] flex w-full items-center justify-center rounded-[5px] bg-gray-50 px-16 py-4 text-gray-700">
              <div className="text-[14px] text-gray-700">{t(n_caf.trend.score_detail)}</div>
              <div className="ml-16 text-[14px] font-bold text-gray-700">{data.level_exact}</div>
            </div>
          ) : (
            <div className="flex flex-row items-center justify-start">
              <div className="mt-[12px] flex w-full items-center justify-center rounded-[5px] bg-gray-50 px-16 py-4 text-gray-700">
                <div className="border-r-1 flex w-[50%] flex-row justify-center border-gray-100">
                  <div className="text-[14px] text-gray-700">{t(n_caf.past_lesson)}</div>
                  <div className="ml-16 text-[14px] font-bold text-gray-700">
                    {(Number(data.level_exact) - Number(diffDataAsTag.band_diff)).toFixed(1)}
                  </div>
                </div>
                <div className="flex w-[50%] flex-row justify-center">
                  <div className="text-[14px] text-gray-700">{t(n_caf.this_lesson)}</div>
                  <div className="ml-16 text-[14px] font-bold text-gray-700">{data.level_exact}</div>
                </div>
              </div>
              <div
                className="mt-12 ml-4 flex flex-row items-center justify-center rounded-[4px] py-4 pl-5 pr-10"
                style={{ backgroundColor: diffColors.bg }}
              >
                <Icon />
                {diffDataAsTag.band_diff !== 0 && (
                  <span className="text-[14px] font-bold" style={{ color: diffColors.text }}>
                    {Math.abs(diffDataAsTag.band_diff).toFixed(1)}
                  </span>
                )}
              </div>
            </div>
          )}
        </Card>
        <div className="mx-[20px]">
          {isFirst ? (
            <p className="text-sBody  mb-[24px]">
              {t(findWordingKey(n_caf, { key: [CAF_ANALYSIS_TYPE_MAP[3], `caf_level${data?.level_rough}`] }))}
            </p>
          ) : (
            <div
              className="border-1 relative mb-12 rounded-[8px] p-12"
              style={{
                borderColor: diffColors.border,
              }}
            >
              <div
                className="absolute left-0 top-0 rounded-tl-[8px] rounded-br-[8px] px-[12px] py-[4px] text-[14px] font-bold"
                style={{
                  color: diffColors.text,
                  backgroundColor: diffColors.bg,
                }}
              >
                {title}
              </div>
              <div className="mt-[23px] text-[14px] text-gray-600">
                {description
                  ? description
                  : t(findWordingKey(n_caf, { key: [CAF_ANALYSIS_TYPE_MAP[3], `caf_level${data?.level_rough}`] }))}
              </div>
            </div>
          )}
          <LevelDescription status={'Fluency'} level={data?.level_rough} />
          <div className="h-24" />
        </div>
      </>
    )
  } else {
    return (
      <>
        <Card clx="mb-[12px] bg-white mt-[16px]">
          <div className="flex justify-between">
            <span className="text-[20px] font-bold text-purple-500">
              <span className="text-purple-500 ">
                {t(n_caf.fluency.level_score)} {data.level_rough}
              </span>
              <span className="text-gray-200 ">/9</span>
            </span>
          </div>
          <ProgressBarNoDetail levelExact={data?.level_exact} totalNum={CAF_LEVEL_MAX} hideFraction />
          {isFirst ? (
            <div className="mt-[12px] flex w-full items-center justify-center rounded-[5px] bg-gray-50 px-16 py-4 text-gray-700">
              <div className="text-[14px] text-gray-700">{t(n_caf.trend.score_detail)}</div>
              <div className="ml-16 text-[14px] font-bold text-gray-700">{data.level_exact}</div>
            </div>
          ) : (
            <div className="flex flex-row items-center justify-start">
              <div className="mt-[12px] flex w-full items-center justify-center rounded-[5px] bg-gray-50 px-16 py-4 text-gray-700">
                <div className="border-r-1 flex w-[50%] flex-row justify-center border-gray-100">
                  <div className="text-[14px] text-gray-700">{t(n_caf.past_lesson)}</div>
                  <div className="ml-16 text-[14px] font-bold text-gray-700">
                    {(Number(data.level_exact) - Number(diffDataAsTag.band_diff)).toFixed(1)}
                  </div>
                </div>
                <div className="flex w-[50%] flex-row justify-center">
                  <div className="text-[14px] text-gray-700">{t(n_caf.this_lesson)}</div>
                  <div className="ml-16 text-[14px] font-bold text-gray-700">{data.level_exact}</div>
                </div>
              </div>
              <div
                className="mt-12 ml-4 flex flex-row items-center justify-center rounded-[4px] py-4 pl-5 pr-10"
                style={{ backgroundColor: diffColors.bg }}
              >
                <Icon />
                {diffDataAsTag.band_diff !== 0 && (
                  <span className="text-[14px] font-bold" style={{ color: diffColors.text }}>
                    {Math.abs(diffDataAsTag.band_diff).toFixed(1)}
                  </span>
                )}
              </div>
            </div>
          )}
        </Card>
        <div>
          {isFirst ? (
            <p className="text-sBody  mb-[24px]">
              {t(findWordingKey(n_caf, { key: [CAF_ANALYSIS_TYPE_MAP[3], `caf_level${data?.level_rough}`] }))}
            </p>
          ) : (
            <div
              className="border-1 relative mb-12 rounded-[8px] p-12"
              style={{
                borderColor: diffColors.border,
              }}
            >
              <div
                className="absolute left-0 top-0 rounded-tl-[8px] rounded-br-[8px] px-[12px] py-[4px] text-[14px] font-bold"
                style={{
                  color: diffColors.text,
                  backgroundColor: diffColors.bg,
                }}
              >
                {title}
              </div>
              <div className="mt-[23px] text-[14px] text-gray-600">
                {description
                  ? description
                  : t(findWordingKey(n_caf, { key: [CAF_ANALYSIS_TYPE_MAP[3], `caf_level${data?.level_rough}`] }))}
              </div>
            </div>
          )}
          <LevelDescription status={'Fluency'} level={data?.level_rough} />
          <div className="h-24" />
        </div>
      </>
    )
  }
}

export default FluencyIntroSection
